var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('LoadingSpinner',{staticClass:"login-loading-spinner",attrs:{"loading":true,"color":'#70A300',"size":'200px',"borderWidth":'14px'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }